import React, { useEffect, useState } from 'react';
import { Table, Button, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

interface DepositoData {
  id: number;
  descripcion: string;
  alta: number; 
}



const ListarDepositos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  console.log('empresa',empresa);
  const sucursal = user?.id_sucursal;
  console.log('sucursal',sucursal);
  const [data, setData] = useState<DepositoData[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKey, setSelectedRowKey] = useState<number>();
  const { getAccessTokenSilently , isLoading } = useAuth0();
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(false);


  const columns: ColumnsType<DepositoData> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
    },
    {
      title: 'Estado',
      dataIndex: 'alta',
      key: 'alta',
      render: (value: number) => (
        <span>
          {value === 1 ? 'Alta' : 'Baja'}
        </span>
      ),
      filters: [
        { text: 'Alta', value: 1 },
        { text: 'Baja', value: 0 }
      ],
      onFilter: (value, record) => record.alta === value
    }
  ];

  const fetchDepositos = async () => {
    setLoading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const ruta = `${process.env.REACT_APP_INSUMOS_URL}/listar_depositos/${empresa}/${sucursal}`;
      console.log('ruta', ruta);
      console.log('empresa', empresa);
      console.log('sucursal', sucursal);

      const response = await fetch(ruta, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      
      if (!response.ok) {
        throw new Error('Error al cargar los depositos');
      }
      
      const result = await response.json();
      console.log('Datos recibidos:', result);
      setData(result);
      
    } catch (error) {
      console.error('Error completo:', error);
      message.error('Error al cargar los depositos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading || !empresa || !sucursal) {
      return;
    }

    fetchDepositos();
  }, [isLoading, empresa, sucursal]);

  const handleAgregarClick = () => {
  //  message.warning('Editar depositos');
    navigate('/crear_depositos');
  };

 const handleSeleccionarClick = () => {
    if (!selectedRowKey) {
      message.warning('Por favor, seleccione un deposito');
    } else {
      navigate(`/editar_depositos/${selectedRowKey}`);
    }

  };

  return (
    <div>
      <Table
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 7,
          total: data.length,
          showSizeChanger: false,
          showTotal: (total) => `Total ${total} registros`,
        }}  
        rowSelection={{
          type: 'radio',
          onChange: (selectedRowKeys: React.Key[], selectedRows: DepositoData[]) => {
            if (selectedRows.length > 0) {
              setSelectedRowKey(selectedRows[0].id);
            }
          },
        }}
      />
      <Button 
      type='primary'
      onClick={handleSeleccionarClick}
      loading={buttonLoading}
      disabled={buttonLoading}
      >{buttonLoading ? 'Seleccionando...' : 'Seleccionar'}</Button>
      <Button 
      type='default'
      onClick={handleAgregarClick}>Nuevo</Button>
    </div>
  );
};

export default ListarDepositos; 